import React from "react";
import * as d3 from "d3";

export default class Relationship extends React.Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.drawSvg();
    }

    drawSvg = () => {
        const {events} = this.props;
        const offset = 40;
        d3.selectAll('#relationship-div>svg.eventRelation').remove();

        events.forEach(event => {
            d3.select('#relationship-div').append('svg')
                .attr('width', 0)
                .attr('height', '100vh')
                .style('position', 'absolute')
                .attr('transform', 'translate(' + (event.x + event.width + offset) + ',0)')
                .attr('class', 'eventRelation event-index' + (event.index + 1))
                .attr('id', 'event-index' + (event.index + 1));
        });


        // d3.select('g.event-group')
        //     .selectAll('g.event')
        //     .on('mouseenter', eventPointerEnter)
        //     .on('mouseleave', eventPointerLeave);

        d3.selectAll('g.node')
            .on('pointerenter', entityPointerEnter)
            .on('pointerleave', entityPointerLeave);

        const eventsMap = {};
        events.forEach(event => {
            eventsMap[event.index] = event;
        });

        function entityPointerEnter(node) {
            node['eventIndex'].forEach(i => {
                const data = eventsMap[i];
                animation(data, node)
            })
        }

        function entityPointerLeave(node) {
            node['eventIndex'].forEach(i => {
                pointerLeave(eventsMap[i])
            })
        }

        function animation(data, node) {

            const eventContainer = d3.select('#eventGraph g.event-container');
            const entityContainer = d3.select('#entityGraph g.container');

            const svg = d3.select('#event-index' + (data.index + 1));
            svg.attr('fill', 'red')
            if (myBrowser() === 'Safari') {
                const id = 'event-index' + (data.index + 1);
                document.getElementById(id).style.left = (data.x + data.width + offset) + 'px';
            }
            let list = [];
            const color = {
                location: '#8345a4',
                person: '#99ce7e',
                organization: '#e6b34e'
            };
            const entityTransform = getTransformXY(entityContainer);
            const targetOffsetX = node.x * entityTransform.scale + entityTransform.x;
            const targetOffsetY = node.y * entityTransform.scale + entityTransform.y;

            list.push({
                category: node.category,
                sourceX: 0,
                //模块位移180，事件条目位移13
                sourceY: data.y + 180 + 12.5 + getTransformXY(eventContainer).y,
                targetX: document.documentElement.clientWidth * 0.3 - (data.x + data.width + offset) + targetOffsetX - global.nodeConf[node.size]['nodeRadio'] + 5,
                targetY: document.documentElement.clientHeight * 0.1 + targetOffsetY + 5
            })

            svg.selectAll('path').remove();
            svg.selectAll('path')
                .data(list)
                .enter()
                .append('path')
                .style('stroke', d => color[d.category])
                .style('stroke-width', 2)
                .style('fill', 'rgba(0,0,0,0)')
                .attr('d', d => {
                    const p0 = {x: d.sourceX, y: d.sourceY};
                    const p3 = {x: d.targetX, y: d.targetY};
                    const mx = (p0.x + p3.x) / 2;
                    let p = [p0, {
                        x: mx,
                        y: p0.y
                    }, {
                        x: mx,
                        y: p3.y
                    }, p3];

                    p = p.map(d => [d.x, d.y]);
                    return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
                });
            svg.transition()
                .ease('linear')
                .duration(500)
                .attr('width', document.documentElement.clientWidth * 0.3 - (data.x + data.width + offset) + targetOffsetX - global.nodeConf[node.size]['nodeRadio'] + 5);
        }

        function pointerLeave(data) {
            const svg = d3.select('#event-index' + (data.index + 1));
            svg.transition()
                .ease('linear')
                .duration(500)
                .attr('width', 0);
        }

        function myBrowser() {
            const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
            const isIE = userAgent.indexOf("compatible") > -1
                && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
            const isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
            const isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
            const isSafari = userAgent.indexOf("Safari") > -1
                && userAgent.indexOf("Chrome") === -1; //判断是否Safari浏览器
            const isChrome = userAgent.indexOf("Chrome") > -1
                && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

            if (isIE) {
                const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                const fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion === 7) {
                    return "IE7";
                } else if (fIEVersion === 8) {
                    return "IE8";
                } else if (fIEVersion === 9) {
                    return "IE9";
                } else if (fIEVersion === 10) {
                    return "IE10";
                } else if (fIEVersion === 11) {
                    return "IE11";
                } else {
                    return "0";
                }
            }
            if (isOpera) {
                return "Opera";
            }
            if (isEdge) {
                return "Edge";
            }
            if (isFF) {
                return "FF";
            }
            if (isSafari) {
                return "Safari";
            }
            if (isChrome) {
                return "Chrome";
            }

        }

        function getTransformXY(p1) {
            const split = p1.attr('transform').split('scale');
            const t1 = split[0];
            const t2 = t1.substring(10, t1.length);
            const t3 = t2.substring(0, t2.length - 1).split(',');
            const x = parseFloat(t3[0]);
            const y = parseFloat(t3[1]);
            let scale = 1;
            if (split[1]) {
                const scaleStr = split[1];
                scale = parseFloat(scaleStr.substring(1, scaleStr.length - 1))
            }
            return {x: x, y: y, scale: scale}
        }

    };

    render() {
        return <div id={'relationship-div'} style={{
            position: 'absolute',
            left: 0,
            top: 0,
        }}/>;
    }
}
